module.exports = __webpack_public_path__ + "img/img_monitor.893da9f3.jpg";